import { render, staticRenderFns } from "./event-judge.vue?vue&type=template&id=86276d5a&scoped=true&"
import script from "./event-judge.vue?vue&type=script&lang=js&"
export * from "./event-judge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86276d5a",
  null
  
)

export default component.exports